import { render, staticRenderFns } from "./ClosedComplaints.vue?vue&type=template&id=405be6aa&scoped=true"
import script from "./ClosedComplaints.vue?vue&type=script&lang=js"
export * from "./ClosedComplaints.vue?vue&type=script&lang=js"
import style0 from "./ClosedComplaints.vue?vue&type=style&index=0&id=405be6aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405be6aa",
  null
  
)

export default component.exports